import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { securityHttpInterceptor } from './http-interceptors/security-http-interceptor';
import { routes } from './app.routes';
import { AppSettingsService } from './services/app-settings.service';
import { BrowserPushService } from './services/web-push/browser-push.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([securityHttpInterceptor])),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })),
    provideAppInitializer(() => {
      // Begin the account-scoped device lifecycle before session restoration.
      inject(BrowserPushService);
      return inject(AppSettingsService).load();
    })
  ]
};
